import React, {useState, useEffect, useContext} from 'react'
import './index.scss'
import BuildCalendar from './BuildCalendar'
import StylingCalendar from './StylingCalendar'
import HeaderCalendar from './HeaderCalendar'
import {ReservationCalendarMainContext} from '../../../../context/ReservationCalendarMain'

export default function Calendar() {
  const [calendar, setCalendar] = useState([])
  const {selectedDate, setSelectedDate, calendarView} = useContext(ReservationCalendarMainContext)

  useEffect(() => {
    setCalendar(BuildCalendar(selectedDate))
  }, [selectedDate])

  function weekHighlight(week) {
    if (calendarView === 'week') {
      if (week.find(day => day.format('MM/DD/YYYY') === selectedDate.format('MM/DD/YYYY'))) {
        return 'day weekHighlight'
      }
    }
    return 'day'
  }

  return (
    <div className="calendar">
      <HeaderCalendar value={selectedDate} setValue={setSelectedDate} />

      <div className="body">
        <div className="day-names">
          {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(d => (
            <div className="week">{d}</div>
          ))}
        </div>
        {calendar.map(week => (
          <div className="">
            {week.map(day => (
              <div className={weekHighlight(week)} onClick={() => setSelectedDate(day)}>
                <div className={StylingCalendar(day, selectedDate)}>{day.format('D')}</div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
